import { useState } from 'react';

import Modal from 'components/shared/Modal/Modal';

import Popover from '../Popovers/Popover/Popover';

import Content from './components/Content/Content';
import ExportButton from './components/ExportButton';

const Export = ({
  showLabel = false,
  customLabel = showLabel ? 'Export' : '',
  useData,
  customContent
}) => {
  const exportConfig = useData();
  const { getData, gridApi, displayExportAs = 'popover', onExportClick } = exportConfig;
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!getData && !gridApi && typeof onExportClick !== 'function') {
    return null;
  }

  if (typeof onExportClick === 'function') {
    return (
      <ExportButton
        open={false}
        customLabel={customLabel}
        onClick={() => onExportClick(exportConfig)}
      />
    );
  }

  if (displayExportAs === 'modal') {
    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);

    return (
      <>
        <ExportButton open={isModalOpen} customLabel={customLabel} onClick={handleOpen} />
        <Modal
          isCentered
          isOpen={isModalOpen}
          handleClose={handleClose}
          disableHeader
          isFooter={false}
          bodyClassName="!p-0">
          <Content {...{ closePopover: handleClose, useData, customContent }} />
        </Modal>
      </>
    );
  }

  return (
    <Popover
      position="left"
      panelClassName="w-[500px] max-w-[calc(100vw-32px)] p-0"
      isFixed
      {...(customLabel && {
        customButtonTrigger: ({ open }) => (
          <ExportButton as="span" open={open} customLabel={customLabel} />
        )
      })}>
      {({ closePopover }) => <Content {...{ closePopover, useData, customContent }} />}
    </Popover>
  );
};

export default Export;
